import { Reveal, SectionLabel } from "./Reveal";

const mission = [
  "Build disciplined traders",
  "Psychology before profits",
  "Structured, step by step education",
  "Small coaching groups",
  "Long term consistency",
];

export default function Philosophy() {
  return (
    <section
      id="about"
      className="relative py-24 sm:py-32 lg:py-40 border-t border-white/5"
      data-testid="about-section"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <Reveal>
          <SectionLabel>About MBM</SectionLabel>
        </Reveal>

        <Reveal delay={0.1}>
          <blockquote className="mt-12 font-heading text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.2] tracking-tight text-zinc-100">
            “Ninety percent of trading is{" "}
            <span className="silver-text">psychology</span>, discipline,
            patience and process. The chart is simply a mirror of the mind
            reading it.”
          </blockquote>
        </Reveal>

        <Reveal delay={0.2}>
          <p className="mt-12 max-w-2xl text-base lg:text-lg text-zinc-400 font-light leading-relaxed">
            At MBM we train the mind first and strategy second. A real edge is not
            found in another indicator or a faster entry, it is built in the
            temperament of the trader. We help you build confidence, manage risk
            and develop the discipline that turns learning into lasting results.
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="mt-16 border-t border-white/10 pt-12">
            <div className="section-label text-[10px] text-zinc-500">Our Mission</div>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6">
              {mission.map((m, i) => (
                <div key={m} className="flex items-center gap-4" data-testid={`mission-point-${i}`}>
                  <span className="font-mono text-xs text-[#6ea8ff]">{String(i + 1).padStart(2, "0")}</span>
                  <span className="text-base text-zinc-200 font-light">{m}</span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
